import React, { useState } from 'react'
import styles from './Collapsible.module.css'
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import GreenTick from "../../../assets/img/green-tick.png"
import YellowWarning from "../../../assets/img/yellow-warning.png"


const Collapsible = (props: any) => {
    const expanded = props.expanded? props.expanded : false;
    const [isOpen, setIsOpen] = useState(expanded);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className={styles.collapsible}>
      <button className={styles.collapsibleHeader}>
        {props.title}
        {props.mfaEnabled && <img src={GreenTick}/>}
        {/* <span className={`${styles.icon} ${isOpen ? styles.open : ""}`}>
          {isOpen ? <AiOutlineDown size={15} color='#1D4ED8' /> : <AiOutlineRight size={15}  color='#1D4ED8'/>}
        </span> */}
      </button>
      <div className={`${styles.collapsibleContent} ${isOpen ? styles.open : ""}`}>
        {props.children}
      </div>
    </div>
  );
}

export default Collapsible